import { render, staticRenderFns } from "./AcceptedAppointmentsSection.vue?vue&type=template&id=9aafd8e4&scoped=true"
import script from "./AcceptedAppointmentsSection.vue?vue&type=script&lang=js"
export * from "./AcceptedAppointmentsSection.vue?vue&type=script&lang=js"
import style0 from "./AcceptedAppointmentsSection.vue?vue&type=style&index=0&id=9aafd8e4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9aafd8e4",
  null
  
)

export default component.exports